import React, { useEffect } from 'react';
import { TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableItemView, TableView } from 'components/shared';
import { SVGAsset } from 'res';
import { DisabledPrompt, BrandingStyle } from "bcms-react";
import NoFilesToDisplayTableRow from '../NoFilesToDisplayTableRow';
import { UICheckbox } from 'components/ui';
import "./styles.css";
import { Link } from "bcms-react";
import { useBCMSModal } from "bcms-react";

/**
 * @function PendingACHPassThruTable
 * @param {String} className - Allows us to set a custom class name for the component
 * @return {React.Component}
 * @exported true
 * @description The table of pending ACH Pass Thru
 */

export default function PendingACHPassThruTable(props) {
  const { pending, passThruACHDetailsModalIsOpen, showFormattedContent, isAllCheckSelected } = props.data ?? {}
  const { onShowFormattedContent, onShowRawContent, onPassThruACHDetailOpenModalClick, onPassThruACHDetailCloseModalClick, onSelectAllCheckmarksChange, onRowChecked } = props.actions ?? {};

  const modalData = {
    passThruACHDetailsModalIsOpen,
    showFormattedContent,
    onShowFormattedContent,
    onShowRawContent,
    onPassThruACHDetailCloseModalClick,
    onPassThruACHDetailOpenModalClick,
    onRowChecked
  }

  const hasPending = pending.length > 0;
  const pendingRows = pending.reduce((acc, item) => {
    acc.push(<PendingACHPassThruItem key={item.id} item={item} modalData={modalData} />);
    return acc;
  }, []);

  return (
    <TableView className="pending-ach-pass-thru-table">
      <TableColumnContainer>
        <TableColumnView text={
          <>
            <UICheckbox label="" value={isAllCheckSelected} onChange={onSelectAllCheckmarksChange}/>
          </>
        } />
        <TableColumnView
          text={
            <>
              <span className="created-by-label">Created By</span>
              <DisabledPrompt>
                <SVGAsset id="SortIcon" className="clickable" />
              </DisabledPrompt>
            </>
          }
        />
        <TableColumnView
          text={
            <>
              <span className="created-label">Created</span>
              <DisabledPrompt>
                <SVGAsset id="ArrowUpIcon" className="clickable" />
              </DisabledPrompt>
            </>
          }
        />
        <TableColumnView
          className="table-medium-column"
          text={
            <>
              <span className="status-label">Status</span>
              <DisabledPrompt>
                <SVGAsset id="SortIcon" className="clickable" />
              </DisabledPrompt>
            </>
          }
        />
        <TableColumnView
          className="table-large-column"
          text={
            <>
              <span className="file-name-label">File Name</span>
              <DisabledPrompt>
                <SVGAsset id="SortIcon" className="clickable" />
              </DisabledPrompt>
            </>
          }
        />
        <TableColumnView />
      </TableColumnContainer>
      <TableBody>
        {hasPending && pendingRows}
        {!hasPending && <NoFilesToDisplayTableRow colSpan="5" />}
      </TableBody>
    </TableView>
  );
}

/**
 * @function PendingACHPassThruItem
 * @return {React.Component}
 * @exported false
 * @description description
 */

function PendingACHPassThruItem(props) {
  
  const modalData = props.modalData ?? {};
  const { onPassThruACHDetailOpenModalClick, passThruACHDetailsModalIsOpen, showFormattedContent, onRowChecked } = modalData ?? {};
  const data = props.item ?? {};
  const numOfParticipants = data.participants ? data.participants.length : 0;
  const { open } = useBCMSModal();

  useEffect(() => {
    if (passThruACHDetailsModalIsOpen) open("PassThruACHDetailsModal", { data, modalData });
  }, [passThruACHDetailsModalIsOpen, showFormattedContent]);

  return (
    <TableItemContainer>
        <TableItemView>
          {/* onChange={ onRowChecked(history.id) } */}
          <UICheckbox label="" value={ data.isChecked}  onChange={ onRowChecked(data.id) }  />
        </TableItemView>
      <TableItemView>
        <p className="username">{data.createdBy}</p>
        {/* <p>Approval Required by System</p> */}
      </TableItemView>
      <TableItemTextView text={data.createdDate.format()}></TableItemTextView>
      <TableItemTextView text={`Pending Approval(s): ${numOfParticipants}`} dataPoint={`Pending_Approval_${data.id}`}></TableItemTextView>
      <TableItemTextView dataPoint={`File_Name_${data.id}`} text={

      <BrandingStyle style={{ "color": "links_abi22" }} className='link clickable' element={  <span  onClick={onPassThruACHDetailOpenModalClick}>{data.fileName}</span>} />
        
      }></TableItemTextView>
      <TableItemView>
        <div className="flex-container flex-horizontal align-center">
          {/* <SVGAsset id="EditIcon" className="table-row-icon clickable" data-point={`Edit_Icon_${data.id}`} /> */}
          <DisabledPrompt>
            <SVGAsset id="TrashcanXIcon" className="table-row-icon clickable" data-point={`Trash_Can_Icon_${data.id}`}  />
          </DisabledPrompt>
        </div>
      </TableItemView>
    </TableItemContainer>
  );
}